export const ActionTypes = {
  LOADING: "ADD_TO_FINALIST_LOADING",
  ERROR: "ADD_TO_FINALIST_ERROR",
  SUCCESS: "ADD_TO_FINALIST_SUCCESS",
};
